import { getTotalExperience } from "../services/utilService";
import { backendExperienceData as experienceData } from "./experience.js";
import { backendResumeSkills as skills } from "./skills.js";
import { profile, resumeFileName } from "./profile.js";

export { experienceData, skills };

export const professionalSummary = (
  <>
    Senior Software Engineer with {getTotalExperience(0.5)} building backend
    systems and AI agent runtimes with Node.js, NestJS, and TypeScript.
    Currently engineering AI agents and platform internals at Lua AI, with
    claims agents live in five countries on a platform serving thousands of
    production agents. Strengths: microservices and event-driven systems, TDD
    and release quality, database and API performance tuning, and data
    pipelines.
  </>
);

export const resumeDownloadOptions = {
  name: profile.name,
  fileName: resumeFileName(" - Backend"),
};
